<!--
component: Login
author: Ken Nakamura
description: ログイン画面
-->
<template>
  <section class="login">
    <div class="head-message">
      <!--
      地図または住所から検索して、概要書を閲覧・印刷することができます。
      -->
      {{headMessage}}
    </div>
    <v-container v-show="pageEnabled">
        <v-row>
          <h4 id="regpwdmsg" v-show="isTouch">
            ※初めてご利用の方は窓口に申請してパスワードを取得して下さい。
          </h4>
        </v-row>
        <v-row>
          <v-col :cols="leftCols" class="border">
            <h3>{{inputIdMessage}}</h3>
            <input v-model="userid" ref="idtext" type="email"
              @focus="selectPasswd(false)"
              @keyup="checkChar"
              @keydown.enter="focusPasswd"
              class="form-control mt-4 mb-4 pwdbox" />
            <h3>パスワードを入力して下さい</h3>
            <input type="password" v-model="password" ref="passwd"
              @focus="selectPasswd(true)"
              @keyup="checkChar"
              @keydown.enter="login"
              class="form-control mt-4 mb-4 pwdbox" />
            <v-row>
              <v-col cols="6">
                <v-btn dark color="#005588" class="acceptButton" @click="login">ログイン</v-btn>
              </v-col>
              <v-col cols="6" v-show="mailVisible">
                <a href="#" @click="sendMail">パスワードを忘れた場合</a>
              </v-col>
            </v-row>
            <Dialog search :open="searching" :cancel="cancelLogin" body="認証中" :width="dialogBkPoint"/>
            <Dialog message :open="canceled" :ok="closeDialog"
              title="ログイン中止" body="ユーザによりキャンセルされました。" :width="dialogBkPoint"/>
            <Dialog error :open="error!=0" :ok="closeDialog"
              title="ログイン失敗" :body="errorMessage" :width="dialogBkPoint"/>
            <!-- <Dialog message :open="mailSending" :ok="mailSend" :cancel="cancelSend"
              title="パスワード再設定" body="パスワード再設定用のメールを送信します。" />
            <Dialog message :open="mailSent" :ok="closeMailSent"
              title="パスワード再設定" :body="resetPasswdMessage" /> -->
            <!--
              パスワード再設定ダイアログ
            -->
            <v-dialog id="changePwddDialog" :width="dialogBkPoint" v-model="mailSending" persistent>
              <v-card>
                <v-card-title>
                  <v-icon large color="primary">mdi-email</v-icon>&nbsp;
                    パスワードの再設定
                </v-card-title>
                <v-card-text v-show="!showMsgFlg" class="py-4 px-6">
                  <v-row>
                    <v-col class="pb-0">
                      パスワード変更メールを送るため登録済みのメールアドレスを入力してください。
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="chgPwdUser"
                        dense
                        placeholder="sample@mail.com"
                        persistent-hint
                        hint="パスワード変更の案内メールが送信されます。">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-show="!sendMailFlg && resetPasswdMessage != ''">
                    <v-col class="py-0">
                      <v-alert
                        dense
                        type="error"
                        style="font-size:1rem;"
                      >
                        {{ resetPasswdMessage }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-show="showMsgFlg" class="py-4 px-6">
                  <v-row>
                    <v-col>
                      <span><v-icon large color="success" class="ma-auto">mdi-check-circle</v-icon>&nbsp;
                        {{ resetPasswdMessage }}
                      </span>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pt-1">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="mailSend()">OK</v-btn>
                  <v-btn text color="primary" v-show="!showMsgFlg" @click="cancelSend()">キャンセル</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col :cols="12-leftCols" v-show="tenkeyVisible">
            <TenkeyPad @pushed="tenkeyPushed($event)" @clear="tenkeyClear" />
          </v-col>
        </v-row>
    </v-container>
  </section>
</template>

<script>
import TenkeyPad from '../components/TenkeyPad.vue'
import Dialog from '../components/Dialog.vue'
import constants from '../common/constants'
import { CallApi } from '../common/apiAccess'

export default {
  data: () => {
    return {
      userid: '', // ログインID
      password: '', // パスワード
      error: 0, // エラー種別フラグ
      inputIdMessage: 'IDを入力して下さい',
      passwdActive: false,
      mailSending: false,
      mailSent: false,
      resetPasswdMessage: '',
      searching: false,
      canceled: false,
      controller: null,
      customErrorMessage: '',
      chgPwdUser: '',
      showMsgFlg: false, // メッセージ表示フラグ(パスワードの再設定ダイアログ)
      sendMailFlg: false, // メール送信成功フラグ
    }
  },
  components: {
    TenkeyPad,
    Dialog,
  },
  watch: {
    userid: {
      immediate: true,
      handler(val) {
        if (val) {
          val = String(val).replace(/[^0-9a-zA-Z@\-_.]/g, '');
          this.$refs.idtext.lazyValue = val;
          this.userid = val;
        }
      }
    },
  },
  computed: {
    clientInfo() {
      return this.$store.state.clientInfo;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    pageEnabled() {
      return this.clientInfo && (this.clientInfo.webEnable || this.clientInfo.category > 0);
    },
    headMessage() {
      return this.pageEnabled ?
       //'地図または住所から検索して、概要書を閲覧・印刷することができます。' :
       '地図または地番から検索して、概要書等を閲覧・印刷することができます。' :
       '現在このページは非公開です。';
    },
    tenkeyVisible() {
      return this.clientInfo?.clientType != 'guest';
    },
    mailVisible() {
      return this.clientInfo?.clientType == 'guest';
    },
    leftCols() {
      if(this.tenkeyVisible && ['xs'].includes(this.$vuetify.breakpoint.name)){
        return 12;
      }else if(this.tenkeyVisible && ['sm'].includes(this.$vuetify.breakpoint.name)){
        return 6;  
      }
      else if (!this.tenkeyVisible) {
        return 10;
      }
      else {
        return 8;
      }
      // return this.tenkeyVisible ? 8 : 12;
    },
    isTouch() {
      return this.$store.state.platform == 'Touch';
    },
    passwordUrl () {
      return constants.passwordUrl;
    },
    errorMessage () {
      switch (this.error) {
      case 1:
        return 'ユーザIDを入力して下さい。';
      case 2:
        return 'パスワードを入力して下さい。';
      case 3:
        return 'IDかパスワードが間違っています。';
      default:
        return this.customErrorMessage;
      }
    },
    jumpAcceptPage () {
      //return this.$store.state.controlAcceptPage && this.clientInfo.clientType == 'guest'
      return this.$store.state.controlAcceptPage && this.userInfo.newUser > 0;
    },
    // ブレークポイント(端末のサイズ・画面サイズ)によって部品のサイズを動的に変える
		dialogBkPoint () {
			switch( this.$vuetify.breakpoint.name) {
				case 'xl':
					return '30%';
				case 'lg':
					return '30%';
				case 'md':
					return '50%';
				case 'sm':
					return '90%';
				case 'xs':
					return '90%';
				default:
					return '30%';
			}
		},
  },
  mounted () {
    sessionStorage.removeItem('madogiwa-terms-agreed');
    sessionStorage.removeItem('madogiwa-authority');
    /* 再取得エラーになるため保留
    //test
    //this.$store.commit('setClientInfo', null);
    //
    try {
      if (!this.clientInfo) {
        CallApi('visited', '/1', (data) => {
          if (data.errorCode) {
            this.customErrorMessage = 'クライアント情報の取得に失敗しました。';
            this.error = 4;
          }
          else {
            this.$store.commit('setClientInfo', data);
          }
        })
      }
    }
    catch (err) {
      console.log(`Login.mounted -> clientInfo error: ${err}`);
    }
    */
    //const clientInfo = localStorage.getItem('ykh-ges-clientInfo');
    const acceptFlg = localStorage.getItem('ykh-ges-acceptFlg');
    localStorage.removeItem('ykh-ges-acceptFlg');
    //if (clientInfo) {
    if (acceptFlg) {
      const token = localStorage.getItem('ykh-ges-token');
      let userInfo = localStorage.getItem('ykh-ges-userInfo');
      const mode = localStorage.getItem('ykh-ges-mode');
      const menuFlag = localStorage.getItem('ykh-ges-menuFlag');
      //this.$store.commit('setClientInfo', clientInfo);
      this.$store.commit('setToken', token);
      //test
      const userId = localStorage.getItem('ykh-ges-userid');
      const userAuth = localStorage.getItem('ykh-ges-userauth');
      const userName = localStorage.getItem('ykh-ges-username');
      const newUser = localStorage.getItem('ykh-ges-newuser');
      userInfo = { id: userId, appMode: mode, authority: userAuth, userName: userName, newUser: newUser };
      //
      this.$store.commit('setUserInfo', userInfo);
      /*
      CallApi('userinfo', `/${userId}`,
        (data) => {
          this.$store.commit('setUserInfo', data);
        });
      */
      if (mode)
        this.$store.commit('setMode', mode);
      this.$store.commit('setMenuFlag', menuFlag);
      localStorage.removeItem('ykh-ges-clientInfo');
      localStorage.removeItem('ykh-ges-token');
      localStorage.removeItem('ykh-ges-userInfo');
      localStorage.removeItem('ykh-ges-mode');
      localStorage.removeItem('ykh-ges-menuFlag');
      if (mode == 0 && menuFlag == 0) {
        this.error = 0;
        this.$store.commit('setToken', '');
        this.$store.commit('setCurrentPage', 0);
        this.$store.commit('setMode', 0);
        this.userid = '';
        this.password = '';
        this.$refs.idtext.focus();
        this.$store.commit('setMessage', 'IDとパスワードを入力して下さい');
        this.inputIdMessage = 'IDまたはメールアドレスを入力して下さい';
      }
      /*
      else if (clientInfo.clientType == 'guest') {
        this.$router.replace('method');
      }
      */
      else {
        this.$router.replace('menu');
      }
    }
    else {
      this.error = 0;
      this.$store.commit('setToken', '');
      this.$store.commit('setCurrentPage', 0);
      this.$store.commit('setMode', 0);
      this.userid = '';
      this.password = '';
      this.$refs.idtext.focus();
      this.$store.commit('setMessage', 'IDとパスワードを入力して下さい');
    }
  },
  methods: {
    tenkeyPushed (val) {
      if (this.passwdActive) {
        this.password = this.password * 10 + val;
      }
      else {
        this.userid = this.userid * 10 + val;
      }
    },
    tenkeyClear () {
      if (this.passwdActive) {
        this.password = '';
      }
      else {
        this.userid = '';
      }
    },
    selectPasswd (flag) {
      this.passwdActive = flag;
    },
    focusPasswd () {
      this.$refs.passwd.focus();
    },
    checkChar () {
      if (this.passwdActive) {
        this.password = this.password.replace(/[^0-9a-zA-Z@\\{}[\]\-_,.=+*;:<>/?!"#$%&'`()~^|]/g, '');
      }
      else {
        this.userid = this.userid.replace(/[^0-9a-zA-Z@\-_.]/g, '');
      }
    },
    login () {
      if (this.userid == '') {
        this.error = 1;
      }
      else if (this.password == '') {
        //(this.password);
        this.error = 2;
      }
      else {
        /*
        this.$router.push({
           name: 'loading',
           params: {
              action: 0,
              userName: this.userid,
              password: this.password
          }});
        */
        this.searching = true;
        this.controller = CallApi('authorize',
          { username: this.userid, password: this.password },
          (data) => {
            this.searching = false;
            if (data.errorCode) {
              //this.error = 3;
              this.customErrorMessage = data.message;
              this.error = 4;
              return;
            }
            else {
              this.$store.commit('setToken', data.token);
              this.$store.commit('setUserInfo', data);
              this.$store.commit('setMode', 0);
              sessionStorage.setItem('madogiwa-authority', data.authority);
              sessionStorage.removeItem('madogiwa-terms-agreed');
              //test
              console.log(`login: auth=${data.authority},appmode=${data.appMode},env=${data.env},new=${data.newUser}`);
              //
              localStorage.setItem('ykh-ges-clientInfo', this.clientInfo);
              //if (this.clientInfo.clientType == 'guest') {
              if (this.jumpAcceptPage) {
                localStorage.setItem('ykh-ges-token', data.token);
                localStorage.setItem('ykh-ges-userInfo', data);
                //local storageへのオブジェクト保存・取り出しはうまく行かない
                localStorage.setItem('ykh-ges-userid', data.id);
                localStorage.setItem('ykh-ges-userauth', data.authority);
                localStorage.setItem('ykh-ges-username', data.userName);
                localStorage.setItem('ykh-ges-newuser', data.newUser);
              }
              /*
              this.$store.commit('setToken', data.token);
              this.$store.commit('setUserInfo', data);
              this.$store.commit('setMode', 0);
              */
              if (data.appMode) {
                if (data.appMode < 0xff) {
                  //if (this.clientInfo.clientType == 'guest') {
                  if (this.jumpAcceptPage) {
                    localStorage.setItem('ykh-ges-mode', data.appMode);
                  }
                  else {
                    this.$store.commit('setMode', data.appMode);
                    this.$router.replace(data.authority == 5 ? 'terms-agreement' : 'method');
                  }
                }
                else {
                  //if (this.clientInfo.clientType == 'guest') {
                  if (this.jumpAcceptPage) {
                    localStorage.setItem('ykh-ges-mode', 0);
                    localStorage.setItem('ykh-ges-menuFlag', data.appMode & 0xff);
                  }
                  else {
                    this.$store.commit('setMenuFlag', data.appMode & 0xff);
                    this.$router.replace(data.authority == 5 ? 'terms-agreement' : 'menu');
                  }
                }
              }
              else {
                //if (this.clientInfo.clientType == 'guest') {
                if (this.jumpAcceptPage) {
                  localStorage.setItem('ykh-ges-mode', 0);
                  localStorage.setItem('ykh-ges-menuFlag', 0xff);
                }
                else {
                  this.$store.commit('setMenuFlag', 0xff);
                  this.$router.replace(data.authority == 5 ? 'terms-agreement' : 'menu');
                }
              }
            }
          //if (this.clientInfo.clientType == 'guest') {
          if (this.jumpAcceptPage) {
            //同意ページに遷移する前にログイン情報をクリア
            //同意ページ側で同意したことを示す情報をlocal storageにでも保存しないと意味ない？
            this.$store.commit('setClientInfo', null);
            this.$store.commit('setToken', '');
            this.$store.commit('setUserInfo', null);
            this.$store.commit('setMode', 0);
            this.$store.commit('setMenuFlag', 0);
            //同意ページに遷移
            location.href = this.$store.state.acceptPageUrl;
          }
        });
      }
    },
    sendMail () {
      this.mailSending = true;
    },
    mailSend () {
      if(!this.showMsgFlg){
        //ToDo: メール送信処理
        CallApi('SendPasswdMail', `?mailAddress=${this.chgPwdUser}`, (data) => {
          // this.mailSending = false;
          if (data.errorCode) {
            this.sendMailFlg = false;
            this.resetPasswdMessage = '登録されているID（メールアドレス）を入力して下さい。';
          }
          else {
            this.sendMailFlg = true;
            this.showMsgFlg = true;
            this.resetPasswdMessage = '仮パスワードの記載されたメールを送信しました。';
          }
          this.mailSent = true;
        });
      }
      else {
        this.mailSending = false;
        location.reload();
      }
    },
    cancelSend () {
      this.chgPwdUser = '';
      this.resetPasswdMessage = '';
      this.sendMailFlg = false;
      this.showMsgFlg = false;
      this.mailSending = false;
    },
    cancelLogin () {
      this.controller.abort();
      this.searching = false;
      this.canceled = true;
    },
    closeDialog () {
      this.error = 0;
      this.searching = false;
      this.canceled = false;
    },
    closeMailSent () {
      this.mailSent = false;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/common/common.css";

#regpwdmsg {
  font-size: 1.5rem;
}
.visible {
  display: block;
}
.invisible {
  display: none;
}
.pwdbox {
  background-color: white;
  font-size: 2.0rem;
  padding: 0.2em;
  width: 100%;
}
.acceptButton {
  font-size: 1.5rem;
  padding: 0.4em 2em;
  margin: 0.2em;
}
.error {
  /*
  background-color: thistle;
  color:tomato;
  */
  font-size: 1.5rem;
  padding-bottom: 0.3em;
}
</style>
